import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Typography, Grid, Container, CardMedia } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Message, MessageSections } from "../../components/message/message";
import BarekamText from "../../components/text";

import { default as MainContainer } from '../../home/components/Container';
import CardItem from "../../home/components/Card/CardItem";
import { Title } from "../../home/components/Title/Title";
import Layout from "../../home/components/Layout";

import { BlogPostModel } from "../../shared/models/blogModel";
import blogService from "../../../services/blog-service";
import { useAppSelector } from "../../../redux/store";
import { StandardResponseModel } from "../../shared/models/standard-response-model";
import { getMessage } from "../../shared/helper-functions";

const Header = styled(Typography)({
  fontSize: "2rem",
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: "20px",
});

const ContentWrapper = styled(Container)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "justify",
});

const ImageWrapper = styled(Box)({
  width: "100%",
  maxWidth: "600px",
  marginBottom: "20px",
  margin: '0 auto'
});

const RelatedBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
  gap: 14px;

  @media screen and (max-width: 768px) {
      flex-direction: column;
  }
`;

const BlogSingle: React.FC = () => {
  const { slug } = useParams();
  const [data, setData] = useState<BlogPostModel>();
  const [related, setRelated] = useState<BlogPostModel[]>([]);
  const { languageId, messageCache } = useAppSelector((state) => state.messagesReducer);

  useEffect(() => {
    if (slug && !data) {
      blogService.getPostBySlug(slug).then((post: any) => {
        setData(post.data);
      });
    }
  }, [slug]);

  useEffect(() => {
    if (slug && data?.id) {
      blogService.getPosts().then((posts: StandardResponseModel<BlogPostModel>) => {
        const tmp = posts.data.filter(post => post?.categoryIds?.includes(data?.categoryIds?.[0] || 1) && post?.id !== data?.id);
        setRelated(tmp);
      });
    }
  }, [slug, data]);

  return (
    <Layout>
      <MainContainer>
        {data && (
          <div>
            <Header>
              <Title>
                {data?.title[languageId]}
              </Title>
            </Header>
            <Grid container spacing={4} justifyContent="center">
              {data?.imgUrl && (
                <Grid item xs={12} md={12}>
                  <ImageWrapper>
                    <CardMedia
                      component="img"
                      image={data?.imgUrl}
                      alt={data?.title[languageId]}
                    />
                  </ImageWrapper>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                <ContentWrapper>
                  <BarekamText variant={"m"} fontWeight={500} align={"left"}>
                    <div dangerouslySetInnerHTML={{ __html: data?.description[languageId] }}></div>
                  </BarekamText>
                </ContentWrapper>
              </Grid>
            </Grid>
          </div>
        )}
      </MainContainer>
      {related?.length > 0 && (
        <Box sx={{ background: '#F1F1FB', width: '100%', marginTop: '60px' }}>
          <Title sx={{ marginTop: '60px' }}>
            <Message
              messageKey={"related_stories"}
              sectionId={MessageSections.MAIN}
            />
          </Title>
          <MainContainer>
            <RelatedBox>
              {related.map(item => (
                <CardItem {...item} />
              ))}
            </RelatedBox>
          </MainContainer>
        </Box>
      )}
    </Layout>
  );
};

export default BlogSingle;
